import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { cascadestore, cascadeedit, cascadedelete, cascadelist } from '../request';
export default {
  props: {
    index: {
      type: Number // 传过来index作为唯一index作为标识
    },
    formDataArray: {
      type: Array
    },
    itemmark: {
      type: String
    }
  },
  data() {
    return {
      saveItem: null,
      currentOptions: [],
      treeData: [{
        name: '全部数据',
        idx: 0,
        value: '',
        level: 0,
        children: []
      }],
      dialogVisible: false,
      form: {
        name: '',
        // 名字
        value: '',
        // 标识
        level: 0,
        // 层级
        // id: 0, // 添加pId属性并设置初始值
        idx: 0
      },
      maxLevel: 6,
      idx: 0
    };
  },
  created() {},
  mounted() {
    this.GETcascadelist(); // 自定义列表接口数据
    // this.GETcascadeedit(); //编辑接口数据
  },
  computed: {
    indexID() {
      return this.index;
    }
  },
  methods: {
    // type 是 string CUSTOM自定义
    // name 是 int 层级名称
    // mark 是 int 层级值标识
    // controlMark 是 int 控件标识
    // level 是 int 层级 例子：1、2、3、4、5最多5级
    // pId 是 int 父级ID （一级默认为0）
    // 自定义新增
    async GETlogistics(item1, parentNode) {
      console.log('item1------------', item1);
      console.log('parentNode------------', parentNode);
      this.currentOptions = await cascadestore({
        type: 'CUSTOM',
        // CUSTOM自定义
        name: item1.name,
        // 层级名称
        controlMark: this.formDataArray[this.indexID].mark,
        // 层级值标识
        level: item1.level,
        // 层级 例子：1、2、3、4、5最多5级
        mark: item1.value,
        // 控件标识
        pId: item1.pId // 父级ID （一级默认为0）
      });
      let currentItem = null;
      const findNode = data => {
        Array.isArray(data) && data.forEach(nodeItem => {
          if (nodeItem.children && nodeItem.children.length > 0) {
            findNode(nodeItem.children);
          }
          if (nodeItem.mark === item1.value) {
            currentItem = nodeItem;
          }
        });
      };
      // debugger
      findNode(this.currentOptions);
      let resItem = this.currentOptions.filter(item => item.mark === item1.value);
      if (currentItem) {
        let id = currentItem.id;
        item1.idx = id;
        parentNode.data.children.push(item1);
      }
      this.GETcascadelist(); //更新列表数据

      // this.formDataArray[this.indexID].Customvalues = this.currentOptions;
      // this.$emit('tree-cascade', this.formDataArray[this.indexID].Customvalues);
    },
    // 自定义 编辑-----------------------------------------------------------
    async GETcascadeedit(item1) {
      this.currentOptions = await cascadeedit({
        type: 'CUSTOM',
        name: item1.name,
        mark: item1.value,
        controlMark: this.formDataArray[this.indexID].mark,
        // 层级值标识
        cascadeId: item1.level
      });
      console.log('自定义 编辑-', this.currentOptions);
    },
    // 自定义删除-------------------------------------------------------------
    async GETcascadestore(item, level) {
      this.currentOptions = await cascadedelete({
        cascadeId: level //层级 （自定义ID）
      });
      console.log('自定义删除', this.currentOptions);
    },
    // 自定义列表---------------------------------------------------------------------------
    async GETcascadelist() {
      this.currentOptions = await cascadelist({
        type: 'CUSTOM',
        controlMark: this.form.value,
        is_hierarchy: false
      });
      // 将数据传给下拉框
      this.formDataArray[this.indexID].Customvalues = this.currentOptions;
      // this.treeData = this.formDataArray[this.indexID].Customvalues;
      this.$emit('tree-list', this.formDataArray[this.indexID].Customvalues);
    },
    renderContent(h, {
      node
    }) {
      const {
        name,
        value,
        children
      } = node.data;
      return h("span", {
        "style": "font-size: 18px;height:50px;line-height: 50px;"
      }, [h("span", {
        "style": "margin-right:50px;"
      }, [h("span", ["\u5B57\u5178\u503C\uFF1A"]), name]), h("span", [h("span", ["\u503C\u6807\u8BC6\uFF1A"]), value]), h("span", {
        "style": "margin-left:100px;"
      }, [h("el-button", {
        "attrs": {
          "type": "text",
          "icon": "el-icon-plus"
        },
        "on": {
          "click": () => this.addChild(node)
        },
        "directives": [{
          name: "show",
          value: node.level < this.maxLevel
        }]
      }, ["\u6DFB\u52A0"]), h("el-button", {
        "attrs": {
          "type": "text",
          "icon": "el-icon-edit"
        },
        "on": {
          "click": () => this.editItem(node)
        }
      }, ["\u7F16\u8F91"]), h("el-button", {
        "attrs": {
          "type": "text",
          "icon": "el-icon-delete"
        },
        "on": {
          "click": () => this.removeItem(node)
        }
      }, ["\u5220\u9664"])])]);
    },
    // 追加
    addChild(parentNode) {
      this.dialogVisible = true;
      this.idx++;
      // debugger;
      this.form = {
        name: '',
        // 名字
        value: '',
        // 标识
        level: parentNode.data.level + 1,
        // 下一级层级
        idx: this.idx,
        pId: parentNode.data.idx // 父级ID
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.saveItem = () => {
        this.$refs.form.validate(valid => {
          if (valid) {
            const {
              name,
              value,
              level,
              pId
            } = this.form;
            const childNode = {
              name,
              value,
              level,
              pId,
              idx: this.idx,
              children: []
            };
            // parentNode.data.children.push(childNode);
            console.log('获取pid值------------', pId);
            console.log('childNode------------', childNode);
            this.GETlogistics(childNode, parentNode); // 将 childNode 传递给服务器进行保存操作
            this.dialogVisible = false;
          }
        });
      };
    },
    // 编辑
    editItem(node) {
      this.dialogVisible = true;
      this.form = {
        name: node.data.name,
        value: node.data.value,
        level: node.data.level // 新增层级
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.saveItem = () => {
        this.$refs.form.validate(valid => {
          if (valid) {
            node.data.name = this.form.name;
            node.data.value = this.form.value;
            node.data.level = this.form.level;
            this.GETcascadeedit(this.form); // 调用编辑接口
            this.dialogVisible = false;
          }
        });
      };
    },
    // // 删除
    removeItem(node) {
      const parentNode = node.parent;
      const index = parentNode.data.children.findIndex(child => child.id === node.data.id);
      parentNode.data.children.splice(index, 1);
      const deletedNodeData = {
        ...node.data
      }; // 创建与节点数据相同的副本
      const levelToDelete = deletedNodeData.level; // 获取要删除节点的层级
      this.GETcascadestore(deletedNodeData, levelToDelete); // 调用自定义删除接口并传递副本对象和层级参数
    }

    // removeItem(node, data) {
    //   const parent = node.parent;
    //   const children = parent.data.children || parent.data;
    //   console.log('删除事件', children);
    //   console.log(data);
    //   const index = children.findIndex(d => d.idx === data.idx);
    //   children.splice(index, 1);
    //   console.log('删除事件----------------', children.splice(index, 1));

    //   // this.GETcascadestore(); // 调用自定义删除接口并传递副本对象和层级参数
    // }

    // // 删除
    // removeItem(node) {
    //   const parentNode = node.parent;
    //   console.log('获取删除的子节点', parentNode.data);

    //   const index = parentNode.findIndex(child => child.id === node.data.id);
    //   parentNode.data.splice(index, 1);
    //   console.log('删除的', parentNode.data.splice(index, 1));
    //   this.updateParentNode(parentNode); // 更新父级节点
    // },
    // // 更新父级节点
    // updateParentNode(node) {
    //   if (node.parent) {
    //     this.updateParentNode(node.parent);
    //   } else {
    //     this.GETcascadestore(node.data.id); // 将删除的节点的 id 值传递给删除接口
    //   }
    // }
  }
};